import { inject, Inject, Injectable, ProviderToken } from '@angular/core';
import { FormTemplateInterface } from '../interfaces/form-template.interface';
import { AbstractControl } from '@angular/forms';
import { DefaultFormValue } from '../interfaces/default-form-value.interface';
import { FormServicesInjectionToken } from '../constants/form-services.injection-token';

/**
 * This class contains a map with services which implement FormTemplateInterface. Each Service is responsible of creating a different form.
 * This class can be configured in a different way in all the apps (Look the constructor)
 */
@Injectable()
export class FormHelperService {
  private availableFormTemplates: Map<string, FormTemplateInterface<DefaultFormValue>> = new Map<
    string,
    FormTemplateInterface<DefaultFormValue>
  >();

  /**
   * The FormServicesInjectionToken contains the map with the key we want to use for each form and the class we want to use for it.
   * In the constructor we instantiate the services and put them into the map.
   * @param availableFormTemplates
   * @example task-container.component > providers
   */
  constructor(
    @Inject(FormServicesInjectionToken)
    availableFormTemplates: Map<string, ProviderToken<FormTemplateInterface<DefaultFormValue>>>
  ) {
    availableFormTemplates.forEach(
      (formTemplateServiceProviderToken: ProviderToken<FormTemplateInterface<DefaultFormValue>>, key: string) => {
        this.availableFormTemplates.set(key, inject(formTemplateServiceProviderToken));
      }
    );
  }

  /**
   * Retrieves the service from the map and calls it's getTemplate method
   * @param template
   * @param defaultValue
   */
  getTemplate(template: string, defaultValue: DefaultFormValue): AbstractControl {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.getService(template)!.getTemplate(defaultValue);
  }

  getService(template: string): FormTemplateInterface<DefaultFormValue> | undefined {
    return this.availableFormTemplates.get(template);
  }
}
